//export const API_BASE_URL = 'http://localhost:62930/api/';

//export const API_BASE_URL = 'https://api.medezweb.com/api/';
export const API_BASE_URL = 'https://apidamar.medezweb.com/api/';
//Export const API_BASE_URL = 'https://api.pbhospital.com/api/';
//Export const API_BASE_URL = 'https://api.medezweb.nrcuae.ae/api/';
//Export const API_BASE_URL = 'https://apidemocompany.medezweb.com/api/';

//Export const API_BASE_URL = 'https://testapi.medezweb.com/api/';
//Export const API_BASE_URL = 'https://qa_api.medezweb.com/api/';
